var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping-cart",attrs:{"id":"shopping-cart"}},[_c('h3',[_vm._v("Shopping Cart")]),_c('serviceCart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }